import axios from "axios";

const b2bOpsAxios = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
});

export default b2bOpsAxios;
